export default {
  id: "ID",
  dashboard: "Dashboard",
  warning: "Warning",
  users: "Users",
  farms: "Farms",
  animals: "Animals",
  action: "Action",
  actionList: "Action List",
  drugInventory: "Drug Inventory",
  inseminatorStatistics: "Inseminator Statistics",
  organizationNTR: "Organization NTR",
  genotypePerformance: "Genotype Performance",
  semenAutomation: "Semen Automation",
  activityLogs: "Activity Log",
  username: "User Name",
  title: "Title",
  deactivated: "Deactivated",
  name: "Name",
  email: "Email",
  emailAddress: "Email Address",
  mobileNum: "Mobile Number",
  emailOrMobile:"Email/Mobile",
  role: "Role",
  roles: "Roles",
  department: "Department",
  status: "Status",
  pages: "Pages",
  departments: "Departments",
  password: "Password",
  cancel: "Cancel",
  submit: "Submit",
  error: "error",
  success: "success",
  Browse: "Browse",
  orDropYourFileCsvXlsXlsxHere: "or drop your file (CSV, XLS, XLSx) here",
  search: "Search",
  apply: "Apply",
  select: "Select",
  previous: "Previous",
  mandatory: "Mandatory",
  dropYourFileHere:
    "or drop your file (CSV, XLS, XLSx, PDF,Docx,PNG,JPEG) here",
  restoreDefault: "Restore Default",
  pending: "Pending",
  completed: "Completed",
  remove: "Remove",
  update: "Update",
  removeFile: "Remove File",
  uploadFile: "Upload File",
  pleaseChoosePreferedLanguage: "Please choose your preferred language",
  edit: "Edit",
  activate: "Activate",
  deactivate: "Deactivate",
  recievedOrders: "Recieved Orders",
  chartRepresentation: "Chart Representation",
  nameIsRequired: "Name is required",
  export: "Export",
  noFilesAvailable: "NO FILES AVAILABLE",
  selectDepartmentToshowRoles: "Select a department to show roles",
  selectDepartmentWithActiveRoles: "Select a department with active roles",
  nameCanContainOnlyAlphabets: "Name can contain only alphbets",
  nameMustBeLessThan15Chars: "Name must be less than 30 characters",
  emailRequired: "Email is required",
  invalidEmailFormat: "Invalid Email Format",
  mobNumReq: "Mobile number is required",
  invalidMobFormat: "Invalid mobile number format.",
  passwordRequired: "Password is required",
  departmentReq: "Department is required",
  roleReq: "Role is required",
  unableToUpdate: "Unable to update",
  orignalName: "Original Name",
  uploadedDate: "Uploaded Date",
  fileName: "File Name",
  importNum: "Import Number",
  languagePreferences: "Language Preference",
  pleaseTryAgainAfterSometime: "Please try after sometime",
  noChanges: "No Changes",
  nothingchanged: "Nothing Changed",
  pleaseChooseAnImageFile: "Please choose an image file",
  fileIsTooBigSelectUnder1MB:
    "Your file is too big! Please select an image under 1MB",
  phoneShouldHave10Chars: "Phone should have 10 characters",
  onlyCSVAllowed: "Only CSV file is allowed",
  loadingPleaseWait: "Loading... Please wait",
  manager: "manager",
  administrator: "administrator",
  Comingsoon: "Coming Soon",
  totalAnimals: "Total Animals",
  receivedOrders: "Received Orders",
  drugs: "Drugs",
  detailedAnalysis: "Detailed Analysis",
  barGraphRepOfActiveUsersAndDeactivateUsers:
    "Bar Graph Representation of Active Users and Deactive Users",
  barGraphRepOfRegAnimalsVsFarm:
    "Bar Graph Representation of Registered Animals Vs Farm",
  roleNumber: "Role Number",
  roleName: "Role Name",
  active: "Active",
  inactive: "InActive",
  admin: "Admin",
  addRole: "Add Role",
  addRoles: "Add Roles",
  permissions: "Permissions",
  sr: "Sr.",
  moduleName: "Module Name",
  view: "View",
  deptNo: "Dept No.",
  selectByCategory: "Select By category",
  weeklyAnalytics: "Weekly Analytics",
  pregnancy: "Pregnancy",
  analytics: "Analytics",
  calendar: "Calendar",
  productName: "Product Name",
  volumeSold: "Volume Sold",
  recordPoints: "Record Points",
  inStock: "In Stock",
  revenue: "Revenue",
  stockStatus: "Stock Status",
  barChart: "Bar Chart",
  lineChart: "Line Chart",
  indexReturns: "Index Returns",
  chart: "Chart",
  time: "time",
  production: "Production",
  customization: "Customization",
  recordsPerPage: "Records per Page",
  noDataAvailable: "No Data Available",
  reporting: "Reporting",
  optional: "Optional",
  note: "Note",
  notes: "Notes",
  date: "Date",

  kG: "KG",
  weight: "weight",
  type: "Type",
  lessthan3Month: "<3 Month",
  lessthan6Month: "<6 Month",
  lessthan7Month: "<7 Month",
  lastWeek: "Last Week",
  thisWeek: "This Week",
  lessthanOneYear: "<1 Years",
  lessthanTwoYear: "<2 Years",
  lessthanThreeYear: "<3 Years",
  lessthanFourYear: "<4 Years",
  yes: "Yes",
  no: "No",
  of: "of",
  notSpecified: "Not Specified",
  days: "days",
  day: "day",
  aDay: "a day",
  years: "years",
  year: "year",
  unit: "unit",
  units: "Units",
  to: "to",
  profile: "Profile",
  logOut: "Logout",
  Unit: "Unit",
  otherSettings:"Other Settings",
  somethingWentWrong: "something went wrong.",
  toDo: "To Do",
  loadingData: "Loading Data...",
  taskNumber: "Task Number",
  taskName: "Task Name",
  startDate: "Start Date",
  dueDate: "Due Date",
  reason: "Reason",
  quantity: "Quantity",
  cost: "Cost",
  noRecordFound: "No Record Found",
  dailyUpdates: "Daily Updates",
  weeklyUpdates: "Weekly Updates",
  moduleAccessed: "Module Accessed",
  typesOfAccess: "Types of Access",
  userId: "UserId",
  lastLogin: "Last Login",
  terminalID: "Terminal ID",
  geographicalAccessPoint: "Geographical Access Point",
  iPAddress: "IP Address",
  fileAccessed: "File Accessed",
  functionAccessed: "Function Accessed",
  webPageURL: "Web Page URL",
  accessType: "Access Type",
  unsuccessfulLoginAttempts: "Unsuccessful Login Attempts",
  customerAddress: "Customer Address",
  orderdate: "Order Date",
  postageDate: "Postage Date",
  postID: "Post ID",
  packingTechnician: "Packing Technician",
  packingTechnicia: "Packing Technicia",
  packEdit: "Pack Edit",
  batchNumber: "Batch Number",
  collectionTechnician: "Collection Technician",
  collectionTechnicia: "Collection Technicia",
  preparationTechnicia: "Preparation Technicia",
  preparationTechnician: "Preparation Technician",
  approvedManually: "Approved Manually",
  researcher: "Researcher",
  dateOfApproval: "Date Of Approval",
  approvalEdit: "Approval Edit",
  searchByAllExceptDate: "Search By All except Date",
  approval: "Approval",
  collection: "Collection",
  postage: "Postage",
  pack: "Pack",
  straws: "Straws",
  createdAt: "Created At",
  sireID: "Sire ID",
  economicIndexValue: "Economic Index Value",
  latestCollectionDate: "Latest Collection Date",

  locationId: "Location Id",

  lastUpdated: "Last Updated",

  print: "Print",
  save: "Save",
  tax: "Tax",
  phoneNo: "Phone No",
  exportAsPDF: "Export as PDF",

  statusUpdated: "Status Updated",
  statusNotUpdated: "Status Not Updated",

  inProgress: "In Progress",
  assignedTo: "Assigned To",
  taskId: "Task id",
  createdDate: "Created date",
  numberOfAnimals: "Number of Animals",
  healthRecordSubmittedSuccess: "Health Record Submitted successfully",
  healthRecordSubmitted: "Health Record Submitted.",
  InseminationRecordSubmittedSuccesful:
    "Insemination Record Submitted successfully",
  inseminationRecordSubmitted: "Insemination Record Submitted.",
  actionListDailyTask: "Action List - Daily Task",
  sinceLastYear: "Since Last Year",
  sinceLastQuarter: "Since Last Quarter",
  sinceLastMonth: "Since Last Month",
  sinceLastWeek: "Since Last Week",
  drugWithdrawPeriod: "DrugWithdraw Period",
  diagnosisName: "Diagnosis Name",
  animalWithNoGenetype:
    "This animal don't have any Genotype data registered. Click the button below to register.",
  nameOfPreviousOwner: "Name of Previous Owner",
  avatarSize: "Avatar size should be less than 1 MB!",
  testDestination: "Test Destination",
  animalNotAdded: "Animal Not Added",
  registerationSuccessful: "Registration Successful",
  backToAnimalList: "Back to Animal List",
  addAnotherAnimal: "Add another Animal",
  animalDetailsUpdated: "Animal details updated successfully",
  animalUpdatedSuccessfully: "Animal Updated Successfully",
  animalNotUpdated: "Animal Not Updated",
  notMember: "Not a member?",
  requestAccess: "Request access",
  typePassword: "Please type password.",
  minChars: "minimum 6 characters",
  typeConfirmPassword: "type confirm password",
  passConfig: "The password confirmation does not match.",
  invalidEmailMobile: "Invalid email/mobile format",
  passwordNotEmpty: "Password can not be empty",
  passwordLength: "Password lenght can not be less then 8 characters",
  cityVillage: "City / Village",
  districtRegion: "District / Region",
  alreadyHaveAnAccount: "Alreday have an account?",
  genetypeUpdated: "GenoType Updated",
  genetypeNotUpdated: "GenoType Not Updated",
  sellTrade: "Sell/Trade",
  milkingDevon: "Milking Devon Breeding Stock for Sale",
  detailedDescription: "Detailed Description",
  longPara:
    "American Milking Devon Bulls heifers and cows. All are registered purebreds. our animals are well socialized, and raised only on grass, hay and lots of love. These beautiful animals are a rare tripple purpose breed for milk, meat oroxen. A-1-A2 & A-2A-A2 stock available. Please call or email for more information or to arrange a herd vist.",
  contactSeller: "Contact Seller",
  enterListingTitle: "Enter Listing Title",
  livestocktype: "Livestock Type",
  uploadImage: "Upload An Image",
  mobilePhone: "Mobile Phone Number",
  myLivestock: "My Livestock",
  livestockObservations: "Livestock Observations",
  selectFromRegisteredAnimals: "Select From List Of Registered Animals",
  selectOption: "Select Option",
  selectTypeObservation: "Select Type Of Observation",
  attachVeteinaryDocument: "Attach Veterinary Document",
  addsensorReading: "Add Sensor Reading",
  myDocument: "My Documents",
  enterAKeyword: "Enter a Keyword",
  documentType: "Document Type",
  registerEditLivestock: "Register/Edit Livestock",
  editLivestockProfile: "Edit Livestock Profile",
  copy: "Copy",
  dateOfRegister: "Date of Register",
  livestockType: "Livestock Type",
  registerNewLivestock: "Register New Livestock",
  enterUniqueTag: "Enter Unique Tag #",
  color: "Color",
  gender: "Gender",
  male: "Male",
  female: "Female",
  damm: "Dam #",
  siree: "Sire #",
  dateOfSaleAuction: "Date of Sale/Auction Sale",
  auctionRecord: "Auction Record of Deathlist",
  distinguishingFeatures: "Distinguishing Features",
  keywordListing: "Keyword or Listing ID",
  adType: "Ad Type",
  activeListingFund: "1 Active Listing Found",
  setupSensors: "Set Up Sensors",
  serialNumber: "Serial Number",
  sensorLocation: "Sensor Location",
  sensorType: "Sensor Type",
  installationDate: "Installation Date",
  ExpirationDate: "Expiration Date",
  addGeo: "Add Geolocation",
  addMoreSensors: "Add More Sensors",
  trackAndTrace: "Track and Trace",
  createNewShipment: "Create a New Shipment",
  workflowReference: "Workflow Reference",
  invoiceDate: "Invoice Date",
  trackShipment: "Track Shipment",
  totalShipments: "Total Shipments",
  activeShipment: "Active Shipments",
  completedObjectives: "Completed Objectives",
  processedPayments: "Processed Payments",
  pointOfDestination: "Point of Destination",
  sellerInformation: "Seller Information",
  selectSellerConsignor: "Select Seller/Consignor",
  pointOfOrigin: "Point of Origin",
  buyerInfo: "Buyer Information",
  selectBuyerConsignor: "Select Buyer/Consignor",
  addSensorTriggers: "Add Sensor Triggers",
  processPayments: "Process Payments",
  defineShippingContract: "Define Shipping Contract",
  addDigitize: "Add & Digitize Documents",
  currentlyOnFarm: "Currently on Farm",
  addSire: "Add Sire",
  addApproval: "Add Approval",
  addCollection: "Add Collection",
  addStraws: "Add Straws",
  addPack: "Add Pack",
  addPostage: "Add Postage",
  searchBySire: "Search By Sire",
  anyDataChangeMightBeLost: "Any data changes might be lost",
  wouldYouLikeToSaveOrWantToLeaveWithoutSaving:
    "Would you like to save or want to leave without saving",
  leave: "Leave",
  stay: "Stay",
  animalFarm: "Animal Farm",
  animalFarmH: "Animal Farm",
  animalOrigin: "Animal Origin",
  animalOriginH: "Animal Origin",
  farmOfOrigin: "Farm Of Origin",
  farmOfOriginH: "Farm Of Origin",
  selectFarm: "Select Farm",
  searchFarm: "Search Farm",
  confirmation: "Confirmation",
  proceed: "Proceed",
  ok: "OK",
  animal: {
    tagH: "Tag",
    tagNumberH:
      "Tag Number: You may add colour as well as number. Its not limited to only numbers.",
    goveRegNoH:
      "Number given while registering with a government organization",
    birthWeightH: "Birth Weight of Calf",
    birthEaseH:"Birth in livestock is a natural process but sometimes there can be birth problems where the dam needs assistance from the farmer/pastoralist.",
    birthFarmH: "Farm of animal origin/birth.",
    surrogateDamH: "The ID of the female cow in which the fertilised egg from a donor male and donor female is implanted for its further development.",
    ownerH: "This is the name of the owner of the animal.",
    damH: "The ID of female parent/mother of the animal.",
    sireH:"The ID of Male parent/father of the animal.",
    breedH: "A breed is a specific group of domestic animals having homogeneous appearance (phenotype), homogeneous behavior, and/or other characteristics that distinguish it from other organisms of the same species.",
    conceptionMethodH: "How the animal was conceived.",
    genderH: "Gender of the animal.",
    dobH: "Date of birth of the animal.",
    operatorH: "The name of the person who fills in this animal's information.",
    removalFarmH: "Animal Removed Farm ",
    dateOfRemovalH: "Date of animal removal",
    destinationOfRemoval: "Destination place of removed animal",
    reasonOfRemovalH: "Reason of animal removement",
    trackingNumberH: "Number assigned to the animal when the animal is removed",
    brandH: "Brand-Simply a permanent mark which was burned onto the cow.",
    tattoH: "Tattoo on animal.",
    hornStatusH: "Whether the animal is dehorned.",
    animalOriginH: "The country of origin of animal.",
    previousOwnerH:
      "Name of previous owner of the animal in case it is a mature one.",
    twinH: "This field says whether the animal has a twin or not.",
    regBreedAssoNoH: "Registration with breed Associations/Societies.",
    breedAssoNameH:
      "Name of Associations/Societies where the animal was registered",
    breederH: "This is the name of the organization which supplied the animal.",
    breeder: "Breeder",
    noteH: "Important note(s) about the animal.",

    accuracyWeight_for_field: "Accuracy Weight",
    conception: "Conception",

    addAnAnimal: "Add An Animal",
    addAnimal: "Add Animal",
    registerAnAnimal: "Register an Animal",
    uploadAnAnimal: "Upload an Animal",

    animalRegistration: "Animal Registration",
    animalDetails: "Animal Details",

    tag: "Tag",
    tagNumber: "Tag Number",
    govtRegNumber: "Govt. Registration Number",
    birthWeight: "Birth Weight (lbs)",
    birthEase: "Birth Ease",
    birthFarm: "Birth Farm",
    surrogateDam: "Surrogate Dam",
    owner: "Owner",
    ownershipType: "Ownership Type",
    animalDiseaseRecord: "AnimalDiseaseRecord",
    govtReg: "Govt. Reg",
    regDate: "Reg Date",

    dam: "Dam",
    sire: "Sire",
    heifer: "Heifer",
    steer: "Steer",
    calf: "Calf",
    farmHerd: "Farm/Herd",
    femaleCalf: "Female Calf",
    maleCalf: "Male Calf",
    newCalves: "New Calves",

    breed: "Breed",
    conceptionMethod: "Conception Method",
    gender: "Gender",
    dateOfBirth: "Date of Birth",
    operator: "Operator",
    animalRemovedFarm: "Animal Removed Farm",
    dateOfAnimalRemoval: "Date of Animal Removal",
    destinationOfRemovedAnimal: "Destination of Removed Animal",
    reasonOfRemoval: "Reason of Removal",
    optionalAnimalInformation: "Optional Animal Information",
    animalPicture: "Animal Picture",
    trackingNumber: "Tracking Number",
    brand: "Brand",
    tatto: "Tattoo",
    hornStatus: "Horn Status",
    animalOrigin: "Animal Origin",
    previosOwner: "Previos Owner",
    twin: "Twin",
    InABreedAssociation: "Reg. # in a Breed Association",
    nameOfBreedAssociations: "Name of Breed Associations",
    breedAssociations: "Breed Associations",
    breederSupplier: "Breeder (Supplier)",
    importAnimal: "Import Animal",
    loadingAnimals: "Loading Animals... Please wait",
    totalRegAnimals: "Total Reg. Animals",
    totalPregnantAnimals: "Total Pregnant Animals",
    pregnantAnimalHistory: "Pregnant Animal History",
    dailyAnimalPregnancyUpdates: "Daily Animal Pregnancy Updates",
    animalHistory: "Animal History",
    dailyAnimalUpdates: "Daily Animal Updates",
    totalPregnant: "Total Pregnant",
    totalNewBorn: "Total New Born",

    searchByIDGOVRegTag: "Search By ID,GOV Reg and Tag",
    noANIMALAVAILABLE: "NO ANIMAL AVAILABLE",

    associationNumber: "Association Number",
    associationName: "Association Name",

    destinationName: "Destination Name",

    plastic: "Plastic",
    metal: "Metal",
    naturalMating: "Natural Mating",
    artificialInsemination: "Artificial Insemination",
    embryoTransfer: "Embryo Transfer",
    noAssistance: "No Assistance",
    someAssistance: "Some Assistance",
    mechanicalAssistance: "Mechanical Assistance",
    aCesareanSection: "A Cesarean section",
    abnormalDelivery: "Abnormal Delivery",
    male: "Male",
    female: "Female",
    castrated: "Castrated",
    sale: "Sale",
    slaughter: "Slaughter",
    death: "Death",
    theft: "Theft",
    other: "Other",
    horned: "Horned",
    polled: "Polled",
    dehorned: "Dehorned",

    details: "Details",
    performance: "Performance",
    geneticWorth: "Genetic Worth",
    healthRecord: "Health Record",
    genotypeData: "Genotype Data",
    reminders: "Reminders",
    activityLog: "Activity Log",
    activityLogDetails: "Activity Log Details",

    editAnimal: "Edit Animal",

    familyInfo: "Family Info",
    breedInfo: "Breed Info",
    identification: "Identification",
    removalInfo: "Removal Info",

    iDOfAnimalDam: "ID of animal's dam.",
    iDOfAnimalSire: "ID of animal's sire.",
    iDOfDamEmbryoUsed: "ID of dam the whos embryo was used.",
    animalHasATwinOrNot: "Whether the animal has a twin or not.",

    breedType: "Breed Type",
    breedOfTheAnimal: "This is a breed of the animal.",
    regBreedAssociations: "Registration with breed Associations/ Societies.",
    nameOfAssociationsSocieties:
      "Name of Associations/Societies where the animal was registered.",
    nameOfTheOrgSuppliedAnimal:
      "This is the name of the organization which supplied the animal.",

    countryOriginAnimal: "The country of origin of animal.",
    birthFarmID: "Birth Farm ID",
    farmIDAnimalBorn: "The farm ID where the animal was born.",
    currentOwner: "Current Owner",
    nameOfOwnerAnimal: "This is the name of the owner of the animal.",
    registrationDate: "Registration Date",
    previousOwner: "Previous owner",
    nameOfOperator: "Name of operator",

    dateAnimalRemoved: "Date when animal is removed.",
    destinationPlaceRemovedAnimal: "Destination place for removed animal",
    namePersonFillAnimalInformation:
      "The name of the person who fills in this animal's information.",
    reasonOfAnimalRemoval: "Reason of animal removal",
    reasonWhyTheAnimalIsRemoved: "Reason why the animal is removed",
    processingDate: "Processing date",
    DateInformationFilledChanged:
      "The date when the current information was filled in or changed.",

    animalID: "Animal ID",
    UniqueIdAnimal: "This is unique id of the animal.",
    plasticTagNumber: "Plastic Tag Number",
    numberAnimalTag: "Number of the Animal tag.",
    rFTagNumber: "RF Tag Number",
    numberAnimalRFTag: "Number of the animal RF tag.",
    govtRegNumb: "Govt. Reg Number",
    govtRegistrationNumber:
      "Identification details that may include the individual’s name and address, the individual’s agent for service of process, the location of the activity to be performed, and a description of the service the individual provides.",
    numberAssignedAnimalIsRemoved:
      "Tracking number is one of the IDs of animals used for tracking the animal activity.",
    dateOfAnimalRegistration: "Date of animal registration",
    stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal:
      "Brand-Simply a permanent mark which was burned onto the cow.",
    tattoOnAnimal: "Tattoo on animal.",
    whetherTheAnimalIsDehorned: "Whether the animal is dehorned.",
    milkingAnimals: "Milking Animals",
    studAnimals: "Stud Animals",
    animalInseminationRecord: "Animal Insemination Record",

    numOfStrawsOrdered: "Number Of Straws Ordered",
    totalNumOfStraws: "Total Number Of Straws",
    strawId: "Straw Id",
    addSireAutomation: "Add Sire Automation",
    addApprovalAutomation: "Add Approval Automation",
    addCollectionAutomation: "Add Collection Automation",
    addStrawsAutomation: "Add Straws Automation",
    addPackAutomation: "Add Pack Automation",
    addPostageAutomation: "Add Postage Automation",
    searchBySire: "searchBySire",
    numberOfProgenies: "Number of Progenies",
    sireEdit: "Sire Edit",
    searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId:
      "Search by Straw Id, Total Numbers of straws, Batch Number and Location Id",
    searchByPackIdNumberOfStrawsOrderedPackingTechnicia:
      "Search by Pack Id, Number of straws ordered, Packing Technicia",
    searchByCollectionAndPreparationTechnicia:
      "Search by collection and preparation technicia",
    registerSemenAutomation: "Register Semen Automation",
    addSemenAutomation: "Add Semen Automation",
    strawAutomationRegistered: "Straw Automation Registered",
    strawAutomationRegisteredNotRegistered:
      "Straw Automation Registered not Registered",
    sireAutomationRegistered: "Sire Automation Registered",
    sireAutomationNotRegistered: "Sire Automation not Registered",
    postageAutomationIsRegistered: "Postage Automation is Registered",
    postageAutomationNotRegistered: "Postage Automation Not Registered",
    packAutomationIsRegistered: "Pack Automation is Registered",
    packAutomationNotRegistered: "Pack Automation Not Registered",
    postageAutomationIsUpdated: "Postage Automation is Updated",
    postageAutomationNotUpdated: "Postage Automation Not Updated",
    packAutomationIsUpadted: "Pack Automation is Upadted",
    packAutomationNotUpadted: "Pack Automation Not Upadted",
    collectionAutomationUpdated: "Collection Automation Updated",
    collectionAutomationNotUpdated: "Collection Automation not Updated",
    approvalAutomationIsUpdated: "Approval Automation is Updated",
    approvalAutomationIsNotUpdated: "Approval Automation is Not Updated",
    collectionAutomationRegistered: "Collection Automation Registered",
    collectionAutomationNotRegistered: "Collection Automation not Registered",
    approvalAutomationIsRegistered: "Approval Automation is Registered",
    approvalAutomationIsNotRegistered: "Approval Automation is Not Registered",
    strawAutomationUpdated: "Straw Automation Updated",
    strawAutomationIsNotUpdated: "Straw Automation is not Updated",
    searchSire: "Search Sire",
    strawsEdit: "Straws Edit",
    nextAnimals: "Next Animal",
    performanceInfo: {
      milk: "Milk",
      liveweight: "Liveweight",
      score: "Score",
      fertility: "Fertility",
      measurements: "Measurements",

      dailyProteinYield: "Daily Protein Yield",
      amountProteinMilkCowDay:
        "Amount of protein in milk obtained from a cow in the particular day.",
      dailyMilkYield: "Daily milk yield",
      volumeMilkCowDay:
        "Volume of milk obtained from a particular cow in a particular day.",
      dailyFatYield: "Daily Fat yield",
      amountFatMilkCowDay:
        "Amount of fat in milk obtained from a cow in the particular day.",
      dailyProteinContent: "Daily protein content",
      dailyFatContent: "Daily fat content",
      milkLactose: "Milk Lactose",
      amountLactoseMilk: "Amount of lactose in milk.",
      milkUrea: "Milk Urea",
      indicatorAmountCrudeProtein:
        "Indicator of the amount of crude protein in a cow's diet",
      lactationNumber: "Lactation number",
      ordinalNumLactation: "The ordinal number of lactation.",
      lengthOfLactation: "Length of lactation (e.g. 23 days)",
      lactationLength: "Lactation length",
      milkingFrequency: "Milking Frequency",
      frequcnyOfMilking: "Frequency of milking (e.g. 2 times/ day)",

      liveWeightInformation: "Liveweight Information",
      currentWeight: "Current Weight",
      weightAnimal: "Weight of the animal.",
      postWeaningGain: "Post-Weaning gain",
      dailyGainInAnimalWeightWeaning:
        "Daily gain in animal's weight after weaning.",
      weaningWeight: "Weaning weight",
      weightAnimalMeasuredWeaning:
        "Weight of animal measured in a day of weaning.",
      averageDailyGain: "Average Daily Gain",
      averageAmountWeightAnimalGainFeedingPeriod:
        "The average amount of weight an animal will gain each day during the feeding period",
      carcassWeight: "Carcass weight",
      weightAnimalsHideInternalOrgansRemoved:
        "Weight of animals after the head, hide and internal organs have been removed.",
      weightAtCalving: "Weight at calving",
      weightAtTheTimeOfCalving: "Weight at the time of calving.",
      yearlingWeight: "Yearling Weight",
      weightYearOldAnimal: "Weight of one year old animal.",

      somaticCellScore: "Somatic cell score",
      somaticCellScoreIndicatorMastitis:
        "Somatic cell score as an indicator for mastitis.  The Farmer can detect early signs of mastitis infection by using this test. The SCC is a measure of body cells and white blood cells present in milk. High SCC indicates the presence of infections in the cow’s udder. Low levels of SCC (<200,000/ml) are expected for good extraction of protein from milk. Somatic cell counts are related to the health and cleanliness of the cows and the cleanliness of the housing conditions.",
      lastUpdate: "Last Update",
      bodyConditionScore: "Body condition score",
      scoreAnimalFat:
        "A score of animal with regard to how many fats it has. Condition scores range from 1 (a very thin cow with no fat reserves) to 5 (a severely over-conditioned cow). Ideal condition scores are 3.0–3.25 at dry off and calving, and 2.25–2.75 at peak lactation, with no cows changing condition score class by more than 0.5–0.75 over any lactation period. ",
      teatScore: "Teat score",
      scoreMeasureingShapeTeats:
        "Teat size scores are subjective assessments of teat length and circumference and range from 9 (very small) to 1 (very large). Udder and teat scores should be taken within 24 hours after calving, preferably by one person and on the weakest quarter.",
      udderScore: "Udder Suspension Score",
      scoreMeasureingShapeOfUdder:
        "Score measuring shape of udder (1-9 score). The strength of attachment of the fore udder to the abdomen. The tighter to the body cavity that the udder is placed, the more desirable. This allows the calf to locate the teats more easily and less likely for the teats to drag in the mud.",
      whetherAnimalEasyBirthDifficult:
        "Birth in livestock is a natural process but sometimes there can be birth problems where the dam needs assistance from the farmer/pastoralist.",
      totalLongevity: "Total Longevity",
      survivalLactationTraitCowCulledBreeding:
        "Survival from 1st to 5th lactation. This trait is calculated after the cow is culled and is needed for estimation of breeding value.",
      docility: "Docility",
      circumferenceBullScrotal: "Circumference of bull's scrotal",

      intervalSuccessInsemination:
        "Interval from first to successful insemination.",
      ageAtFirstCalving: "Age At First Calving",
      ageCowCalving: "What is the age of cow in the first calving.",
      calvingInterval: "Calving interval",
      periodCalving: "The period from one calving to the next calving.",
      scrotalCircumference: "Scrotal Circumference",
      estrusDetection: "Estrus Detection",
      trackingBehaviorAnimalDetectingEstrus:
        "Tracking movement behavior of animal for detecting estrus of a cow.",
      presenceOfEstrus: "Presence Of Estrus",
      isCowInEstrusStage: "Is when a cow is on  estrus stage or nor",

      matureWeight: "Mature Weight",
      weightAnimalDefinedAge: "Weight of an animal in a defined age.",
      matureHeight: "Mature Height",
      heightAnimalDefinedAge: "Height of an animal in defined age.",
      footClawSet: "Foot Claw Set",
      shapeAnimalClaw: "Shape of animal's claw.",
      pulmonaryArterialPressure: "Pulmonary Arterial Pressure",
      animalBloodPreasure: "Animal's blood preasure.",
      footAngle: "Foot Angle",
      shapeAnimalFoot: "Shape of animal's foot.",
      ribEyeArea: "Rib-eye Area",
      amountRibEyeArea: "Amount of rib-eye area.",
      ultrasoundFat: "Ultrasound Fat",
      measureFatAmount: "Measure of fat amount.",
      ultrasoundIntramuscularFat: "Ultrasound Intramuscular Fat",
      ultrasoundRibEyeArea: "Ultrasound Rib-Eye Area",
      measureRibeyeArea: "Measure of ribeye area.",
      fatThickness: "Fat Thickness",
      amountAnimalBackFat: "Amount of animal's back fat.",
      marbling: "Marbling",
      marballingMeasurement:
        "Marbling is the visible unsaturated (healthy) intramuscular fat that accumulates within the muscle and between the muscle fibre bundles.",
      dryMatterIntake: "Dry-matter Intake",
      amountFeedAnimalConsumesAMoisture:
        "Amount of feed an animal consumes per day on a moisture-free basis.",
    },

    feedsName: "Feeds Name",
    feedName: "Feed Name",
    firstFeedQuantity: "First Feed Quantity",
    additionalFeed: "Additional Feed",
    cloversRyeGrasses: "Clovers, Rye grasses",
    greenFodderHayLegumes: "Green Fodder, Hay, Legumes",
    feedsRegisteredSuccessfully: "Feeds Registered Successfully",
    feedsNotRegistered: "Feeds Not Registered",

    fEEDQUANTITY: "FEED QUANTITY",
    feedQuantity: "Feed Quantity",
    fEEDNAME: "FEED NAME",
    nOFEEDINFOAVAILABLE: "NO FEED INFO AVAILABLE",
    searchByFeedName: "Search by Feed name",
    loadingFeedInfo: "Loading Feed Info... Please wait",
    todayFeedInfo: "Today Feed Info",
    feedInfo: "Feed Info",
    loremIpsumDolorSitAmet:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lacus sem, maximus vitae interdum in, consequat non sem. Morbi posuere dignissim est ut molestie.",

    geneticWorthInfo: {
      breedingValueEconomicIndex:
        "Whether this breeding value is used for calculation of economic index.",
      dailyProteinYieldUsed: "Daily Protein Yield Used",
      weightAssignedBreedingDailyProteinYield:
        'Weight assigned to breeding value corresponding to "Daily protein yield". This weight is used for calculation of economic index.',
      dailyProteinYieldWeight: "Daily Protein Yield Weight",
      rankAnimalInRelationshipEconomicIndex:
        "Rank of animal in relationship to economic index.",
      economicIndexRank: "Economic Index Rank",
      percentileEconomicIndexFall: "Percentile which economic index falls in.",
      economicIndexPercentile: "Economic Index Percentile",
      accuracyOfEconomicIndex: "Accuracy of economic index.",
      economicIndexAccuracy: "Economic Index Accuracy",
      weightedAverageOfBreedingValues: "Weighted average of breeding values.",
      economicIndex: "Economic Index",

      rankOfAnimalInRelationshipBreeding:
        "Rank of animal in relationship to the corresponding breeding value.",
      dailyProteinYieldBreedingValueRank:
        "Daily protein yield breeding value rank ",
      percentileBreedingFalls: "Percentile which breeding value falls in.",
      dailyProteinYieldBreedingPercentile:
        "Daily protein yield breeding value percentile ",
      accuracyEstimatedBreeding: "Accuracy of estimated breeding value.",
      dailyProteinYieldBreedingAccuracy:
        "Daily Protein Yield Breeding Value Accuracy",
      estimatedBreedingTraitDailyProteinYield:
        'Estimated breeding value of the trait "Daily protein yield.',
      dailyProteinYieldBreedingValue: "Daily Protein Yield Breeding Value ",

      pathToTheDirectoryScriptsBreeding:
        "Path to the directory on hard drive containing scripts which was used for calculation of breeding value.",
      scriptsPath: "Scripts Path",
      softwarePackageBreeding:
        "Software package which was used to calculate breeding value.",
      breedingValueSoftware: "Breeding Value Software",
      methodCalculateBreeding:
        "The method which was used to calculate breeding",
      breedingValueMethod: "Breeding Value Method",

      trait: "Trait",
      tools: "Tools",
      geneticWorth: "Genetic Worth",

      dailyProteinYield: "Daily Protein Yield",
      breedingValue: "Breeding Value",
      breedingValueBIFAccuracy: "Breeding Value BIF Accuracy",
      breedingValuePercentile: "Breeding Value Percentile",
      breedingValueRank: "Breeding Value Rank",
      checkLTD: "Check LTD",
      ultrasoundDiagnostic: "Ultrasound Diagnostic",
      selectYieldUsed: "Select Yield used",
      softwareName: "Software name",

      animalGenWorthUpdatedSuccessfully:
        "Animal Gen Worth updated Successfully",
    },

    addNote: "Add Note",
    enterNote: "Enter Note",
    noteIsRequired: "Note is required",
    noteMustBeLessThan50Characters: "Note must be less than 50 characters",
    noteAdded: "Note Added",
    noteNotAdded: "Note not Added",
    noteForAnimal: "Note for animal.",
    noNoteFoundForThisAnimal: "No note found for this animal.",

    inseminationData: "Insemination Data",
    nameOfInseminator: "Name of inseminator",
    activity: "Activity",
    searchByNameActivity: "Search by name, activity",
    searchByTaskNameNumber: "Search by task name, number",
    inseminationDate: "Insemination Date",

    genotypeDataInfo: {
      genotypeAnimalID: "Genotype Animal ID",
      iDTubeBloodSampleAnimalNumberGenotypingService:
        "This is ID of a tube with a blood sample taken from the animal or a number of genotyping service",
      geneticTechnicianName: "Genetic Technician Name",
      NameTechnicianBloodSamplesAnimal:
        "This is the name of a technician who took blood samples from the animal",
      sNPData: "SNP data",
      genotypingServiceNote: "Genotyping Service Note",
      InfoGenotypingGenotypingTechnology:
        "All the information related to genotyping such as name of genotyping company, genotyping technology used, date of genotyping, etc",
      numberOfSNPs: "Number of SNPs",
      numberOfSNPsAnimalGenotyped:
        "Number of SNPs the animal was genotyped for",

      nameOfTheDrug: "Name of the Drug",
      animalGenoDataUpdatedSuccessfully:
        "Animal Geno Data Updated Successfully",
      animalGenoDataNotUpdated: "Animal Geno Data Not Updated",
      animalIDIsRequired: "Animal ID is required",
      techNameIsRequired: "Tech. name is required",
      onlyAlphabetsAreAllowed: "Only alphabets are allowed",
      genoDataIsRequired: "Geno data is required",
      serviceNoteIsRequired: "Service Note is required",
      sNPIsRequired: "SNP is required",
    },

    healthRecordInfo: {
      treatment: "Treatment",
      treatmentTakenAnimal: "What treatment was taken on animal.",
      reasonOfTreatment: "Reason of Treatment",
      reasonForTreatment: "Reason for Treatment",
      whatReasonOfTreatment: "What is the reason of treatment.",
      treatmentDate: "Treatment Date",
      dateOfTreatment: "Date of treatment.",
      diagnosis: "Diagnosis",
      nameDiagnosedDiseaseConditionSymptoms:
        "Name of diagnosed disease/condition or main symptoms",
      drugID: "Drug ID",
      iDOfDrugWhichIsGivenToAnimal: "ID of drug which is given to animal.",
      drugName: "Drug Name",
      nameDrugAnimal: "Name of drug which is given to animal.",
      drugWithdrawalPeriod: "Drug Withdrawal Period",
      timeAdministrationDrugAnimalMeatMilkHumanConsumption:
        "The time required after administration of a drug to an animal to assure safety of meat or milk for human consumption",
      attendingVeterinarian: "Attending Veterinarian",
      qualifiedPersonCaseAnimal: "The qualified person who saw the case/animal",
      packID: "Pack ID",
      iDPackTreatment: "ID of a pack which was used for treatment",
      veterinarianName: "Veterinarian Name",
      animalNoHealthRecord:
        "This animal don't have any Health Record. Click the button below to register",
      addHealthRecord: "Add Health Record",
      healthStatus: "Health Status",
      loadingDiseasesPleaseWait: "Loading Diseases... Please wait",
      animalDiseaseRecord: "Animal Disease Record",
      animalHealthRecord: "Animal Health Record",
      animalTreatmentRecord: "Animal Treatment Record",
      loadingHealthData: "Loading Health Data...",
      healthRecord: "Health Record",
      nameOfDiagnosis: "Name Of Diagnosis",
      treatmentName: "Treatment Name",
      drugGivenBy: "Drug Given By",
      recessiveDiseases: "Recessive Diseases",
      recessiveDiseasesMessage:
        "Which recessive disease alleles this bull is a carrier of",
    },

    conceptionInfo: {
      addNewConception: "Add new conception",
      semenEmbryo: "Semen/Embryo",
      pregnancyCheck: "Pregnancy Check",
      birthInfo: "Birth Info",
      searchByInseminatorOrganisationBreedingConception:
        "Search by Inseminator name, Organisation name, Breeding service number, Conception method",

      deliveryDate: "Delivery Date",
      calfId: "Calf Id",
      birthDayOldWeight: "Birth (Day Old) Weight",
      searchByBirthEase: "Search by Birth ease",

      searchPregnancyCheckOperatorMethod:
        "Search by Pregnancy check operator, Pregnancy check Method",
      pregnancyCheckDate: "Pregnancy Check Date",
      conceptionSuccess: "Conception Success",
      pregnancyCheckOperator: "Pregnancy Check Operator",
      pregnancyCheckMethod: "Pregnancy Check Method",
      recentlyPregnant: "Recently Pregnant",
      pregnancyConfirmationDate: "Pregnancy Confirmation Date",
      pregnancyRate: "Pregnancy Rate",
      timePeriodOfPregnancy: "Time Period Of Pregnancy",
      semenProduction: "Semen Production",
      embryoProduction: "Embryo Production",
      semen: "semen",
      embryoTransferDate: "Embryo Transfer Date",
      daysOfPregnancy: "Days of Pregnancy",

      searchSireEmbryoSurrogate:
        "Search by Sire id, Embryo org name, Surrogate dam breed",

      selectDate: "Select Date",
      orgnisationNameContainNumber:
        "Orgnisation Name should not contain number",
      selectBirthEase: "Select Birth Ease",
      selectUnit: "Please select an unit",
      animalConceptionAddedSuccessfully: "Animal Conception Added Successfully",
      postageCustomerName: "Postage Customer Name",
      searchByPostageCustNameCustAddPostId:
        "Search by Postage Customer Name, Customer Address, Post Id",
      dateOfSemenCollection: "Date of Semen Collection",
      dateOfSemenPreparation: "Date of Semen Preparation",
      semenMotility: "Semen Motility",
      semenConcentration: "Semen Concentration",
      postageEdit: "Postage Edit",
      enterSireId: "Enter Sire ID",
      selectEmbryoOrganisation: "Select Embryo Organisation",

      matingDateH:
        "Date of conception, either natural mating or artificial insemination.",
      inseminatorNameH:
        "A person who performs the insemination process ( veterinarian/technician)",
      orgNameH:
        "Name of the organization or company that provides the semen straw for AI",
      brServiceNumH: "Recording the number of breeding (e.g. 1st, 2nd, or 3rd)",
      conceptionMethodH:
        "The way the animal conceived that is  beginning of pregnancy, marked by fertilization of an egg by a sperm.",
      sireIdH:
        "The ID of Male parent/father of the animal",
      damIdH:"The ID of female parent/mother of the animal.",
      sarogatedDamH: "The ID of the female cow in which the fertilised egg from a donor male and donor female is implanted for its further development.",
      embOrgNameH: "The organization  name for the embryo",
      sarogateDamBreedH: "The date of the surrogate breed",
      sireBreedH: "The type of the sire breed ( brahman, boran)",
      pregCheckDateH:
        "Pregnancy can be detected in cows as early as 30 days using ultrasound and blood tests.For cows to be identified as pregnant utilizing the palpation method, cows often need to be at least 35-50 days pregnant.  Ultrasounds are used for pregnancy diagnosis at 40 - 75 days of gestation.",
      conceptionSuccessH:
        " In cattle, fertilization rate is 90% with an average calving rate of about 55%, indicating an embryonic-fetal mortality of about 35% (Diskin et al., 2006). Further, 70 to 80% of total embryonic loss occurs during the first three weeks after insemination, particularly between days 7 and 16.",
      pregnancyCheckOperatorH:
        "Veterinarians and specialist animal technicians most commonly provide these services to farmers.  Both procedures are invasive and practitioners require extensive training in order to undertake the procedure safely (for cow and operator) at sufficient accuracy and speed for the service to be economically viable.",
      pregnancyCheckMethodH:
        "The two most frequently used methods for pregnancy diagnosis of cattle are manual palpation of the reproductive tract (per rectum) and transrectal ultrasonography of the reproductive tract",
      deliveryDateH: "Date when the birth delivery happen",

      calfIdH: "ID of new born calf",
      birthEaseH:
        "Birth in livestock is a natural process but sometimes there can be birth problems where the dam needs assistance from the farmer/pastoralist.",
      birthDayOldWeightH:
        "Weight of an animal in the day of birth or weight of a one day old bird",
      customerAddress: "Customer Address",
    },
    all: "All",
    ungrouped: "Ungrouped Animals",
    active: "Grouped Animals",
    updateAnimal: "Update Animal",
  },
  dashboardS: {
    dailyActivities: "Daily Activities",
    pendingTasks: "Pending Tasks",
    performanceOfGeno: "Performance of Genotypes",
    breed: "Breed",
    chromosome: "Chromosome",
    seqChange: "Sequence Change",
    inheritance: "Inheritance",
    diseaseName: "Disease Name",
    refSequence: "Reference Sequence",
    pubmedRef: "Pubmed Reference",
    matingDate: "Mating Date",
    inseminatorName: "Inseminator Name",
    orgName: "Organization Name",
    brServiceNum: "Breeding Service Number",
    conceptionMethod: "Conception Method",
    semEmbInfo: "Semen/Embryo Info",
    sireId: "Sire ID",
    damID: "Dam ID",
    srgDamId: "Surrogate Dam ID",
    embOrgName: "Embryo Org. Name",
    srgDamBreed: "Surrogate Dam Breed",
    sireBreed: "Sire Breed",
    damBreed: "Dam Breed",
  },
  user: {
    selectLanguage:"Select Language",
    unitPreference:"Unit Preference",
    selectUnitOfMeasure:"Select unit of measure",
    importedUser: "Imported User",
    impFileStatus: "Import File Status",
    loadingUser: "Loading Users... Please wait",
    totalUsers: "Total Users",
    pendingUsers: "Pending Users",
    changePassword: "Change Password",
    goodIdeaToUsePassword:
      "It’s a good idea to use a strong password that you’ re not using elsewhere.",
    enterCurrentPassword: "Enter Current Password",
    enterNewPassword: "Enter New Password",
    reEnterPassword: "Re-Enter New Password",
    enterPassword: "Enter Password",
    repeatNewPassword: "Repeat New Password",
    emailAddr: "Email Address",
    enterYourPhoneNumber: "Enter Your Phone Number",
    pleaseTypeOldPassword: "Please type old password.",
    pleaseTypeNewPassword: "Please type new password.",
    pleaseTypeConfirmPassword: "Please type confirm password.",
    passwordChangedSuccesFully: "Password changed successfully",
    currentPassword: "Current Password",
    newPassword: "New Password",
    passwordDoesNotMatch: "Passwords does not match.",
    emailCanNotBeEmpty: "Email can not be empty",
    profileUpdated: "Profile Updated",
    profileNotUpdated: "Profile Not Updated",
    unableToVerifyEmail: "Unable to verify Email",
    otpSentOnEmail: "OTP sent on email",
    otpSentSuccessFully: "OTP sent successfully",
    importUsers: "Import Users",
    imageUpdated: "Image Updated",
    departmentName: "Department Name",
    departmentNum: "Department Number",
    departmentAdded: "Department Added",
    departmentNotAdded: "Department not Added",
    searchDepartnment: "Search By Department Name Or Number",
    addDepartMent: "Add Department",
    addDepartment: "Add Department",
    roleNameIsRequired: "Role name is required",
    roleNameMustBeLessThan15Chars: "Role name must be less than 15 characters",
    roleAdded: "Role Added",
    editDepartment: "Edit Department",
    departmentUpdated: "Department Updated",
    departmentNotUpdated: "Department Not Updated",
    deleteDepartment: "Delete Department",
    deleteDepartmentMessage: "Are you sure you want to delete this department.",
    noRoleAvailable: "NO ROLE AVAILABLE",
    roleUpdated: "Role Updated",
    roleNotUpdated: "Role Not Updated",
    editRole: "Edit Role",
    allRole: "All Role",
    addNewRole: "Add New Role",
    allDepartment: "All Department",
    permissionsUpdated: "Permissions Updated",
    permissionsnotUpdated: "Permissions not Updated",
    roleNo: "Role No.",
    searchByEmailAndName: "Search by email and name",
    userID: "User ID",
    userUpdated: "User Updated",
    userNotUpdated: "User Not Updated",
    userAdded: "User Added",
    userNotAdded: "User Not Added",
    activateUser: "Activate User",
    deactivateUser: "Deactivate User",
    userStatusMsg: "Are you sure you want to change user status",
    countryRequired: "Country is required",
    stateRequired: "State is required",
    cityRequired: "City is required",
    searchByRole: "Search By Role Number, Role Name, Department",
    noModuleAvailable: "No Module Available",
    searchBYModuleName: "Search By Module Name",
  },
  farm: {
    farmID: "Farm ID",
    onTheFarm: "On the Farm",
    userRoles: "User Roles",
    adduser: "Add User",
    addAuser: "Add a User",
    uploadUsers: "Upload Users",
    addNewUser: "Add New User",
    selectDept: "Select Department",
    selectRole: "Select Role",
    editUser: "Edit User",
    totalFarms: "Total Farms",
    NoAnimalsRegisteredForthisFarm: "No Animals are Registered for this Farm",
    farmsPerPage: "Farms per page",
    regularFarms: "Regular Farms",
    farmRegisteredProducts: "Farm Registered Products",
    searchByFarmNameAndId: "Search by Farm Name and Id",
    loadingProductsPleaseWait: "Loading Products... Please wait",
    farmName: "Farm Name",
    farmLocation: "Farm Location",
    productName: "Product Name",
    stockStatus: "Stock Status",
    inStock: "In Stock",
    searchByProductName: "Search By Product Name",
    productCategory: "Product Category",
    products: "Products",

    farms: "Farms",
    registerAfarm: "Register A Farm",
    govtRegistry: "Govt. Registry",
    cooperativeID: "Cooperative ID",
    farmType: "Farm Type",
    contractMating: "Contract Mating",
    customization: "Customization",
    recordsPerpage: "Records per Page",
    restoreDefault: "Restore Default",
    apply: "Apply",
    searchState:
      "Search by Farm ID, Gov. Registry, Cooperative ID, Farm Type, Contract Mating",
    farmOwner: "Farm Owner",
    govRegistrationNo: "Govt Registration Number",
    farmInformation: "Farm Information",
    ownershipType: "Ownership Type",
    communityName: "Community Name",
    farmLicenseInformation: "Farm License Information",
    licenseNumber: "License Number",
    licenseExpiryDate: "License Expiry Date",
    regulatorName: "Regulator Name",
    regulatorRepresentativeName: "Regulator Representative Name",
    farmLocationSize: "Farm Location & Size",
    productionSystem: "Production System",
    country: "Country",
    state: "State",
    city: "City",
    street: "Street",
    houseNumber: "House Number",
    farmRegistration: "Farm Registration",
    cancel: "Cancel",
    register: "Register",
    ok: "ok",
    totalFarmSize: "Total Farm Size",
    farmGeographicLocation: "Farm Geographic Location",
    perimeterPointLongitude: "Perimeter Point Longitude",
    perimeterPointLatitude: "Perimeter Point Latitude",
    perimeterPointLabel: "Perimeter Point Label",
    perimeterLength: "Perimeter Length",
    farmLatitude: "Farm Latitude",
    farmLongitude: "Farm Longitude",
    editFarm: "Edit Farm",
    update: "Update",
    editAfarm: "Edit a farm",
    nextFarm: "Next Farm",
    nameoftheFarm: "Name of the Farm",
    registerAProduct: " Register A Product",
    farmProducts: "Farm Products",
    calf: "Calf",
    steer: "Steer",
    heifer: "Heifer",
    sire: "Sire",
    dam: "Dam",
    registerAnAnimal: "Register An Animal",
    farmAnimals: "Farm Animals",
    farm_type: "Farm-type",
    farm_Owner: "Farm-Owner",
    dateOfRegistration: "Date Of Registration",
    dataIsNotAvailableForThisFarm: "Data Is Not available for this Farm",
    registerNewProduct: "Register A New Product",
    information: "Information",
    licenseInfo: "License Info",
    locationInfo: "Location Info",
    geoLocation: "Geo Location",
    perimeterLengthState: "Length of Farms Perimeter (fence length)",
    totalFarmSizeState: "Size of a Farm",
    productionSystemState: "Production System used in the Farm",
    contractMatingState:
      "Code of Contract Mating Programme in which the Farm Participate.",
    ownershipTypeState: "Type of Ownership",
    regulatorRepresentativeNameState:
      "Name of the person representing regulator who released the license",
    regulatorNameState: "Name of regulator which released the license",
    licenseExpiryDateState: "Date when the current License is Expired",
    licenseNumberState: "License Number released by Regulator",
    plotNumberState: "House number of the farm.",
    plotNumber: "House/Plot Number",
    streetStatement: "Street name of the farm.",
    cityStatement: "City where the farm is located in.",
    stateStatement: "Region of the country where the farm is located in.",
    countryState: "Country where the farm is located in.",
    perimeterPointLongitudeState: "Longitude of one point on farm.",
    perimeterPointLatitudeState: "Latitude of one point on farm.",
    perimeterPointLabelState: "Label of Point.",
    farmLongitudeState: "Longitude of the farm.",
    farmLatitudeState: "Latitude of the farm.",
    farmNameH: "Name of farm",
    farmTypeH:
      "The type of the farm where different activities are carried out.",
    farmOwnerH:
      "Name of owner of a farm (auto-generate Farmer name entering info)",
    ownershipTypeH:
      "The type of farmers who own/control the land they farm and those who do not.",
    govtRegNumbH: "Registry number of the farm which was assigned by regulator",
    contractMatingH:
      "Code of contract mating programm which the farm participate in",
    productionSystemH: "What the production system is used on the farm",
    cooperativeIDH: "ID of a cooperative which the farm is a member of ",
    licenseNumberH:
      "Identifying number on a licence released by regulator that identifies it with the owner.",
    licenseExpiryDateH: "Date when the current license is expired",
    regularNameH: "Name of regulator which released the license",
    regularRepName:
      "Name of the person representing regulator who released the license",
    countryH: "Country where the farm is located in.",
    stateH: "Region of the country where the farm is located in.",
    cityH: "City where the farm is located in.",
    streetH: "Street name of the farm.",
    houseNumberH: "House number of the farm.",
    totalFarmSizeH:
      "Farm size is the sum of land that is currently cultivated by the farm including land under fallow but excluding land under natural vegetation, trees or pasture.",
    farmLatitudeH:
      "Is the measurement of distance north or south of the Equator. It is measured with 180 imaginary lines that form circles around Earth east-west, parallel to the Equator",
    farmLongitudeH: "It measures distance east or west of the prime meridian.",
    perimeterLengthH: "Length of farms perimeter (fence length)",
    perimeterPointLabelH:
      "Label of point. Using three parameters (latitude, longitude and label) we describe perimeter of farm and any segment inside of the farm.",
    perimeterPointLatH: "Latitude of one point on farm",
    perimeterPointLongH: "Longitude of one point on farm",

    noProductAvailable: "No Product Available",
    farmUpdated: "Farm Updated",
    performance: "Performance",
    milkInformation: "Milk Information",
    farmNameRequired: "Farm Name is required",
  },
  login: {
    welcome: "Welcome! Log In",
    welInfo: "Enter your credentials.",
    login: "Login",
    forgotPassword:"Forgot Password",
    forgotPasswordDesc:"Please enter the email address associated with your account. Password details will be sent to your email address.",
    backToLogin:"Back to Login",
  },
  actionListmod: {
    actionList: "Action List",
    tODAY: "Today",
    createTask: "Create Task",
    myActivities: "My Activities",
    jhonSmith: "Jhon Smith",
    farmID: "Farm ID",
    dateOfEvent: "Date of Event",
    actionRequired: "Action Required",
    actionTaken: "Action Taken",
    animalEventID: "Animal Event ID",
    cANCEL: "Cancel",
    cONFIRM: "Confirm",
    sTATEMENT: "Are you sure you want to delete this record?",
    dAY: "Day",
    wEEK: "Week",
    mONTH: "Month",
    sUBMIT: "Submit",
    startDate: "Start Date",
    endDate: "End Date",
    rEPEAT: "Repeat",
    taskCategory: "Task Category",
    pRIORITY: "Priority",
    aSSIGNEE: "Assignee",
    selectLocation: "Select location",
    selectAnimals: "Select one or more animals",
    dESCRIPTION: "Description",
    customRecurrence: "Custom Recurrence",
    repeatEvery: "Repeat Every",
    taskName: "Task name",
    enterDescription: "Enter Description",
    toDo: "To Do",
    assignTo: "Assign To",
    status: "Status",
    nOTE: "Note",
    noTaskAvailable: "NO TASK AVAILABLE",
    healthRecord: "Health Record",
    iD: "ID",
    tAG: "Tag",
    dateOfbirth: "Date Of Birth",
    taskTakenat: "Task Taken At",
    gENDER: "Gender",
    bREED: "Breed",
    regDate: "Reg. Date",
    updateHealthRecord: "Update Health Record for Animals",
    treatment: "Treatment",
    reasonOftreatment: "Reason Of Treatment",
    treatmentDate: "Treatment Date",
    dIAGNOSIS: "Diagnosis",
    drugId: "Drug Id",
    drugName: "Drug Name",
    drugWithdrawalperiod: "Drug Withdrawal Period",
    attendingVeterinarian: "Attending Veterinarian",
    packId: "Pack Id",
    noItemsselected: "No Items Selected",
    healthRecordsubmission: "Health Record Submission",
    inseminationRecordsubmission: "Insemination-Record Submission",
    inseminatorName: "Inseminator Name",
    inseminatorId: "Inseminator Id",
    conceptionRate: "Conception Rate",
    dateOfmeasurement: "Date Of Measurement",
    recordSubmission: "Record Submission",
    uPDATE: "Update",
    updateTask: "Update Task",
  },
  inseminatorStatisticsInfo: {
    addInseminatorInfo: "Add Inseminator Info",
    inseminatorNumber: "Inseminator Number",
    loadingInseminatorPleaseWait: "Loading Inseminator... Please wait",
    searchByIDAndName: "Search by ID and Name",

    inseminatorInfoAdded: "Inseminator Info Added",
    inseminatorInfoNotAdded: "Inseminator Info not Added",

    inseminatorInfoUpdated: "Inseminator Info Updated",
    inseminatorInfoNotUpdated: "Inseminator Info not Updated",
    editAInseminatorInfo: "Edit Inseminator Info",
    inseminatorList: "Inseminator List",
    inseminatorInfoDetails: "Inseminator Info Details",
    updateInseminatorInfo: "Update Inseminator Info",
  },
  organizationNtrInfo: {
    loadingOrdersPleaseWait: "Loading Orders... Please wait",
    addStocks: "Add Stocks",
    addStock: "Add Stock",
    quantity: "Quantity",
    selectUnit: "Select Unit",
    farmProducts: "Farm Products",
    cost: "Cost",
    transactionID: "Transaction ID",
    recipientID: "Recipient ID",
    orderID: "Order ID",
    recepientName: "Recepient Name",

    createAOrder: "Create a order",
    totalStocks: "Total Stocks",
    orders: "Orders",
    totalPending: "Total Pending",
    totalDelivered: "Total Delivered",
    searchByRecepientNameOrderIdRecepientId:
      "Search By Recepient Name, Order Id, Recepient Id",

    chooseTheDate: "Choose the date",
    transactionDate: "Transaction Date",
    selectCategory: "Select Category",
    volumeOfProduct: "Volume Of Product",
    productQuantity: "Product Quantity",
    productRecipientId: "Product Recipient Id",
    productRecipientName: "Product Recipient Name",
    productRecipientType: "Product Recipient Type",
    singleProduct: "Single Product",
    orderPlaced: "Order Placed",
    orderNotPlaced: "Order Not Placed",
    totalPrice: "Total Price",
    currency: "Currency",
    selectCurrency: "Select Currency",
    address: "Address",
    enterAddress: "Enter Address",
    attachments: "Attachments",
    chooseFile: "Choose File",

    nameOfTheFarm: "Name of the farm",
    loremIpsumHasBeenTheIndustrySStandardDummyText:
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a",
    billedTo: "Billed To",
    orderStatus: "Order Status",
    selectStatus: "Select Status",
    cadbury: "Cadbury",
    totalAmount: "Total Amount",
    deliveryCharges: "Delivery Charges",
    orderDetails: "Order Details",

    deliveryOnTime: "Delivery on Time",

    productID: "Product ID",

    productRegistration: "Product Registration",
    enterTheNameOfTheProduct: "Enter the name of the product",
    nameOfTheProduct: "Name Of The Product",
    productAdded: "Product Added",
    productNotAdded: "Product not Added",
  },
  drug: {
    dRUGS: "Drugs",
    registerAdrug: "Register a Drug",
    sEARCH: "Search",
    genericName: "Generic Name",
    manufacturer: "Manufacturer",
    distributor: "Distributor",
    registrationDate: "Registration Date",
    drugRegistration: "Drug Registration",
    drugInformation: "Drug Information",
    packExpiration: "Pack Expiration",
    drugId: "Drug ID",
    drugName: "Drug Name",
    drugGenericname: "Drug Generic Name",
    drugManufacturer: "Drug Manufacturer",
    distributorName: "Distributor Name",
    drugRegistrationdate: "Drug Registration Date",
    nextDrug: "Next Drug",
    editDrug: "Edit Drug",
    updateDrug: "Update Drug",
    deleteDrug: "Delete Drug",
    noRecordfound: "No Record Found",
    addDrug: "Add Drug",
    statementDrug:
      "The drug has been deleted. Click the button below to register. ",
    cANCEL: "Cancel",
    cONFIRM: "Confirm",
    sTATEMENT: "Are you sure you want to delete this record?",
    ok: " ok",
    information: "Information",
    packOrder: "Pack Order",
    packPrescription: "Pack Prescription",
    packReservation: "Pack Reservation",
    packLocation: "Pack Location",
    drugDozedam: "Drug Dose in a day For Dam",
    drugDozecalf: "Drug Dose in a day For Calf",
    drugFormate: "Drug Format",
    drugDistributor: "Drug Distributor",
    drugActiveingridents: "Drug Active Ingredients",
    drugSubstitutionId: "Drug Substitution Id",
    packId: "Pack Id",
    packBatchNumber: "Pack Batch Number",
    drugIdStatement: "The batch number of the drug.",
    drugNameSatement: "The advertised brand name under which the drug is sold.",
    drugGenericnameStatement:
      "The chemical makeup of a drug rather than the advertised brand name under which the drug is sold.",
    drugFormateSatement: "The batch number of the drug.",
    drugDozecalfSatement: "To know the amount of drug dose to calf.",
    drugDozedamStatement: "To know the amount of drug dose to dam.",
    drugManufacturerStatement: "Details of the drug manufacturer.",
    drugDistributorStatement: "Details of the drug distributor.",
    drugRegistrationdateStatement:
      "Date of drug registration in the specific country.",
    drugActiveingridentsStatement: "List of the active ingredients.",
    drugSubstitutionIdStatement:
      "IDs of possible substitutions for the drug in the case the main drug is currently unavailable.",
    packIdStatement: "Bar code or RF ID of the pack.",
    packBatchNumberStatement:
      "The batch number assigned to the pack by the manufacturer.",
    locationWarehouseID: "Location Warehouse ID",
    locationWarehouseIDState: "ID of the warehouse where the pack is stored.",
    locationRackID: "Location Rack ID",
    locationRackIDStatement: "ID of the rack where the pack is stored.",
    locationTierID: "Location Tier ID",
    locationTierIDStatement: "ID of the tier on rack where the pack is stored.",
    locationPositionID: "Location Position ID",
    locationPositionIDStatement:
      "ID of the position on a tier where the pack is stored.",
    storageTemperatureCondition: "Storage Temperature Condition",
    storageTemperatureConditionStats: "Condition of pack storing.",
    containerForm: "Container Form",
    containerFormStatement: "Form of container in which the drug was packed.",
    consistQuantity: "Consist Quantity",
    consistQuantityStatement: "Quantity of pills, bottles, etc in the pack.",
    releaseId: "Release Id",
    releaseIdStatement: "ID which assigned after the pack is taken by farmer.",
    releaseDate: "Release Date",
    releaseDateStatement: "Date when the pack was taken from stock by farmer.",
    packManufacturedDate: "Pack manufactured Date",
    packManufacturedDateStatement: "Date when the pack was manufactured.",
    packImportedDate: "Pack Imported Date",
    packImportedDateStatement: "Date when the pack was imported.",
    packExpirationDate: "Pack Expiration Date",
    packExpirationDateStatement: "Date when the pack is expired.",
    expiredSoonFlag: "Expired Soon Flag",
    expiredSoonFlagState: "Warning about the pack expiring soon.",
    packTotalVolumeLeft: "Pack Total Volume Left",
    packTotalVolumeLeftState:
      "Total number of the packs with the same ingredients left in stock.",
    packOrderID: "Pack Order ID",
    packOrderIDState:
      "ID which was assigned after ordering the pack from distributor.",
    packQuantityOrdered: "Pack Quantity Ordered",
    packQuantityOrderedState:
      "Number of packs which was ordered from distributor.",
    packPrice: "Pack Price",
    packPriceStatement: "Price of pack.",
    priceCurrency: "Price Currency",
    packPricecurrency: "Pack Price Currency",
    packPricecurrencyState: "Currency name in which the price is nominated.",
    packPaydate: "Pack Pay Date",
    payDate: "Pay Date",
    packPaydateState: "Date when the payment was released to the distributor.",
    packShippingID: "Pack Shipping ID",
    shippingID: "Shipping ID",
    packShippingIdState:
      "Shipping id of the pack when it is arrived from distributor.",
    packShippingDate: "Pack Shipping Date",
    shippingDate: "Shipping Date",
    packShippingDateState: "Date of arrival of the pack at the stock.",
    packOrderStatus: "Pack Order Status",
    packOrderStatusState: "Status of the current order.",
    recepientKeeperId: "Recepient Keeper Id",
    recepientKeeperIdStatement:
      "The name of the individual/organization who received the pack.",
    recepientFarmId: "Recepient Farm Id",
    recepientFarmIdStatement:
      "ID of the farm where the animlal drug recepint belong to.",
    recepientAnimalId: "Recepient Animal Id",
    recepientAnimalIdState:
      "ID of the animal to whom the drug (pack) was prescribed to.",
    specialistComments: "Specialist Comments",
    specialistCommentsState:
      "Comments of specialist/veterinary about prescription.",
    specialistName: "Specialist Name",
    specialistNameState:
      "Name of the specialist/veterinary who prescribed the drug.",
    specialistID: "Specialist ID",
    specialistIDState:
      "ID of the specialist/veterinary who prescribed the drug.",
    reservedByKeeperId: "Reserved By Keeper Id",
    reservedByKeeperIdState: "Keeper ID of who reserved the pack.",
    reservedByFarmId: "Reserved By Farm Id",
    reservedByFarmIdState: "Farm ID of which reserved the pack for.",
    reservationTimeoutDate: "Reservation Timeout Date",
    reservationTimeoutDateState:
      "Date when the reservation will be automatically cancelled if the pack is not purchased.",
    reservationTimeout: "Reservation Timeout",
    reservationTimeoutState:
      "Number of hours after which the reservation will be automatically cancelled if the pack is not purchased or taken",
    reservationDate: "Reservation Date",
    reservationDateState: "Reservation  date of the pack.",
    reservationStatus: "Reservation Status",
    reservationStatusState:
      "Status of the pack reservation. The pack is unavailable for others if reserved.",
    loadingDrugsPleaseWait: "Loading Drugs... Please wait",
    quantityOrder: "Quantity Order",
    keeperID: "Keeper ID",
    timeoutDate: "Timeout Date",
    warehouseID: "Warehouse ID",
    rackID: "Rack ID",
    tierID: "Tier ID",
    positionID: "Position ID",
    temperatureCondition: "Temperature Condition",
    manufactureDate: "Manufacture Date",
    importedDate: "Imported Date",
    totalVolumeLeft: "Total Volume Left",
  },
  reports: {
    myReports: "My Reports",
    satelliteReports: "Satellite Reports",
    weatherReports: "Weather Reports",
    pregnancyAnalytics: "Pregnancy Analytics",
    semenEmbroyAnalytics: "Semen/Embroy Analytics",
    semenAnalytics: "Semen Analytics",
    embryoAnalytics: "Embryo Analytics",
    calfAnalytics: "Calf Analytics",
    milkProduction: "Milk Production",
    totalMilkType: "Total Milk Type",
    totalAnimalAnalytics: "Total Animal Analytics",
    animalAnalytics: "Animal Analytics",
    analyticsAndReporting: "Analytics and Reporting",
    filterByCountry: "Filter By Country",
    filterByFarm: "Filter By Farm",
    filterByRegion: "Filter By Region",
    filterByMonth: "Filter By Month",
    filterByDate: "Filter By Date",
    filterByRole: "Filter By Role",
    filterByYear: "Filter By Year",
    filterByTrait: "Filter By Trait",
    avgBreedingValue: "Average Breeding Value",
    avgEconomicIndex: "Average Economic Index",
    breederReport: "Breeder Report",
    semenTransferDate: "Semen Transfer Date",
    semenEmbryoProductionReport: "Semen/Embryo Production Report",
    semenProducts: "Semen Products",
    meatProducts: "Meat Products",
    totalProducts: "Total Products",
    semenEmbryoReport: "Semen/Embryo Report",
    numOfStraws: "Number of Straws",
    collectionDate: "Collection Date",
    productionReport: "Production Report",
    receipientId: "Receipient ID",
    embryoId: "Embryo ID",
    semenStrawId: "Semen Straw ID",
    dataScientist: "Data Scientist",
    dataScientistReport: "Data Scientist Report",
    productReport: "Product Report",
    dairyProducts: "Dairy Products",
  },
  genoPerformance: {
    performanceOfGenoType: "Performance Of GenoType",
    addAGenoType: "Add a GenoType",
    breedName: "Breed Name",
    chromosome: "Chromosome",
    sequenceChange: "Sequence Change",
    inheritance: "Inheritance",
    diseaseName: "Disease Name",
    referenceSequence: "Reference Sequence",
    pubmedReference: "Pubmed Reference",
    genoTypeRegistration: "GenoType Registration",
    breed: "Breed",
    editAGenoType: "Edit a GenoType",
    editGenoType: "Edit GenoType",
    loadingGene: "Loading Geno... Please wait",
    geneTypeList: "GenoType List",
  },
  reportings: {
    conception: "Conception(Data Scientist)",
    performanceOfGenoData: "Performance of Genotype(Data Scientist)",
    totalInsemination: "Total Insemination",
    embryo: "Embryo",
    animalVaccinationRecord: "Animal Vaccination Record",
    dataNotAvailable: "Data Is Not available for this Farm.",
    pregnancyStatus: "Pregnancy Status",
    healthReport: "Health Report",
    heavyMilk: "Heavy Milk",
    standardMilk: "Standard Milk",
  },
  sidebar: {
    healthAnalytics: "Health Analytics",
    productionAnalytics: "Production Analytics",
  },
  epd: {
    regNo:
      "Animal Reg No is the unique code given to animal using a means of marking, ensuring a process done to identify and track specific animals",
    internationalID: "International ID of Animal",
    location: "Country / Region of Animal Birth ",
    animalName: "Standard Name / Nomenclature of The Animal",
    gender: "Sex of the animal (male/female)",
    additionalIDMethod:
      "What method was used to identify the animal (e.g.ear tag, tattoo)",
    damID:
      "ID or Registration number of animal's dam-the female parent of an animal/ID of Number of the biological mother",
    sireId:
      "An ID or Registration number of the male parent of an animal, especially a bull kept for breeding or bulls semen used for Artificial Insemination.",
    dateOfBirth: "Date of birth of the animal.",

    breederHerdCode: "Breeder Herd Code mostly given by Breeder Associations",
    seasonofBirth: "Season of Birth of Animal noted in month wise",
    birthYear: "The year the animal born",
    birthManagementCode: "Birth Management Code mostly provided by user/farmer",
    birthSex: "Gender of the animal (male/female)",
    birthWeight: "Birth Weight of Calf ",
    primaryBreed: "Major % Genetic contribution of the animal ",
    secondaryBreed: "Minor % Genetic contribution of the animal ",
    breedComposition: "Breed composition percentage refers to the proportional representation of different breeds within the genetic makeup of an individual animal or a group of animals. It quantifies the contribution of each breed to the overall genetic composition, expressed as a percentage.",
    conceptionMethod:
      "How the animal was conceived (natural mating/ insemination/embryo transfer).",
    accuracyWeight: "Accuracy Weight",
    damAge: "The age of the dam in months/years e.g. 2 years, 24 months",
    weaningWeight: "Weaning Weight of an animal at the time of  weaning.",
    weaningDate: "The date on which animal was weaned",
    weaningSex:
      "The sex of the animal that was weaned. The sum of the characteristics that distinguish organisms on the basis of their reproductive function.",
    managementPastureCode:
      "Code given to the management/ pasture by user/ farmer ",
    creep:
      "Creep feeding is the practice of providing supplemental feed (grain or forage) to nursing calves.",
    weaningContemporaryGroupCode: "Code of Weaning Weight Contemporary Group",
    birthContemporaryCode: "Birth Contemporary Code",

    yearlingDate:
      "Date of animal one year old or in the second year of its age",
    managementFeedUnitCode: "Code given to the management/ feed unit by user",
    yearlingSex: "The sex of the animal at the time of yearling ",
    yearlingWeight:
      "Yearling Weight is a measurement of direct growth post-weaning and is often used to reflect potential performance of market-bound progeny in the feedlot, measured in pounds of calf.",
    yearlingHeight: "Height of  the animal at the time of yearling ",
    yearlingWeightContemporaryGroupCode:
      "Code of  Yearling Weight Contemporary Group",

    weaningYearlingWeightContemporaryGroupCode:
      "code of Weaning or Yearling Weight Contemporary Group",
    daysOnFeed:
      "Number of days fed with that particular feed Ex: young growing cattle are fed a high-energy diet to produce marketable beef at a low cost of gain. Depending on the starting body weight and age of the cattle, the period of feeding varies from 60 days to 12 months",
    managementFeedUnitPenCode:
      "Code given to the management/ feed unit/pen by user",
    harvestDate: "Date of animal slaughtered ( killed ) for meat",
    gradingDate:
      "Date of  carcasses was graded according to a particular criteria",
    carcassSex: "Sex of the carcass",
    dateonFeed:
      "Date the animal was shifted on to new feed Ex: young growing cattle are fed a high-energy diet to produce marketable beef at a low cost of gain. Depending on the starting body weight and age of the cattle, the period of feeding varies from 60 days to 12 months",
    KPH: "% KPH is the percentage of total fat found in the body cavity of a carcass specifically in the regions of the kidneys, pelvis, and heart. It is often estimated visually by a USDA grader or it can be calculated based on the change in carcass weight following removal of fat from these areas on the carcass. Most carcasses have 1 to 4 percent KPH. It is the last factor used to determine yield grade.",
    carcassWeight:
      "Carcass weight is the hot or unchilled weight after harvest and removal of the hide, head, gastrointestinal tract, and internal organs. It is sometimes reported as Hot carcass weight (HCW). Carcass weight is a major factor in determining carcass value when cattle are sold on a dressed weight basis or on a value-based grid.",
    fatThickness:
      "Fat thickness is measured in inches using a small ruler. The proper place to measure backfat thickness is ¾ of the length up the ribeye from the backbone end, perpendicular to the outside surface of the carcass.",
    marbling:
      "Marbling is the visible unsaturated (healthy) intramuscular fat that accumulates within the muscle and between the muscle fibre bundles.",
    ribeyeArea:
      "Amount of rib-eye (loin or ribeye muscle longissimus dorsi) area measured between the 12th and 13th ribs  in square inches  using a grid (e.g., 8, 9 or 10 inches). Ribeye area is directly related to the amount of muscle in the carcass.",
    animalStatus:"Status of animal in the farm e.g: healthy, sick etc"
  },
  manageAnimalGroupings: {
    resetModeTooltip: `
        RESET MODE <br>
            In this mode <br>
            1) Set/define all the contemporary groups (CGs) characteristics for all traits of interest. <br>
            2) Assign all animals to a corresponding CG. <br>
            3) If the assigning of animals is not satisfactory, adjust/change the CGs, and then again assign the animals to the new corresponding CGs. <br>
            4) Repeat the above steps, if necessary, until you are satisfied the the CGs and corresponding grouping/assigning of animals.<br>
        `,
    maintainanceModeHeadingTooltip: `Once the RESET (mode) is finalized, you will enter the MAINTENANCE MODE where the EDPs calculated at the RESET will be kept constant for each animal until the next RESET (which could be 2-6 months away). Furthermore, any new animals added to or born from animals already in the system during the MAINTENANCE MODE will have their EPDs calculated through another method, an ancestors method, until they are recalculated in the next RESET.`,
    maintainanceModeTooltip: `After completing the RESET MODE, press the RESET FINALISED button to enable the system to calculate the EPDs of all animals, Terminate the RESET MODE, and initiate the MAINTENANCE MODE.`,
    resetToggleTooltip: `Enable Reset Toggle in EPD model setting to assign animals to CGs.`,
  },
  geneticsAndBreeding: {
    geneticsAndBreeding: "Genetics & Breeding",
    geneticSearchTool: "Genetic Search Tool",
    dataSubmission: "Data Submission / Animal Selection",
    animalsWithExpectedProgenyDifferences:
      "Animals Selection for Expected Progeny Differences (EPDs) calculation",
    searchByAnimalIdName: "Search by Animal Id, Name",
    rowsPerPage: "Rows per page",
    individualEntry: "Individual Entry",
    bulkEntry: "Bulk Entry",
    registerANewAnimalOrSelectAnExistingAnimal:
      "Register a new animal or select an existing animal.",
    registerNewAnimal: "Register New Animal",
    selectExistingAnimal: "Select Existing Animal",
    animalID: "Animal ID",
    animalName: "Animal Name",
    tag: "Tag #",
    dateOfBirth: "Date Of Birth",
    gender: "Gender",
    birthDate: "Birth Date",
    birthWeightLb: "Birth Weight (lb)",
    birthWeightKg: "Birth Weight(kg)",
    weaningWeightLb: "Weaning Weight (lb)",
    weaningWeightKg: "Weaning Weight(kg)",
    yearlingWeightLb: "Yearling Weight (lb)",
    yearlingWeightKg: "Yearling Weight(kg)",
    carcassWeightLb: "Carcass Weight (lb)",
    carcassWeightKg: "Carcass Weight(kg)",
    animalSelection: "Animal Selection",
    animalSearchTool: "Animal Search Tool",
    back: "Back",
    searchByEPDs: "Search by EPDs",
    searchByIds: "Search by Ids",
    selectBreed: "Select Breed",
    selectGender: "Select Gender",
    selectRequiredBreedForCattle: "Select Required Breed For Cattle",
    resetFilter: "RESET FILTER",
    birthWeightHeader: "Birth Weight(BW): ",
    birthWeightDef:
      "Compares the differences in the weight of calves at birth and is measured in pounds or kg.",
    weaningWeightHeader: "Weaning Weight(WW): ",
    weaningWeightDef:
      "WW EPD is an estimate of pre-weaning growth that is measured in pounds or kg.",
    yearlingWeightHeader: "Yearling Weight(YW): ",
    yearlingWeightDef:
      "YW EPD is an estimate of post-weaning growth that is measured in pounds or kg.",
    ribEyeAreaHeader: "Ribeye Area(REA): ",
    ribEyeAreaDef:
      "REA measures the size of the muscle that gives us the ribeye in square inches.REA EPDs reflect differences in an adjusted 365-day ribeye area measurement based on carcass measurements of harvested cattle.",
    marblingHeader: "Marbling(MARB): ",
    marblingDef:
      "The MARB EPD is in units of percentage of intramuscular fat within the ribeye.MARB EPDs reflect differences in an adjusted 365-day marbling score (intramuscular fat, [IMF]) based on carcass measurements of harvested cattle.",
    fatThicknessHeader: "Fat Thickness(FAT): ",
    fatThicknessDef:
      "Inches of backfat (in hundredths of an inch) is the unit of measurement for FT.",
    carcassWeightHeader: "Carcass Weight(CW): ",
    carcassWeightDef:
      "Carcass weight is a beneficial trait when considering the impact that pounds have relative to end product value. At the same age constant endpoint, sires with higher values for carcass weight will add more pounds of hot carcass weight compared to sires with lower values for carcass weight.",
    yieldGradeHeader: "Yield Grade(YG): ",
    yieldGradeDef:
      "The USDA Yield Grade scoring system is the unit of measurement for the YG EPD. Yield Grade 1 are leaner, more retail product carcasses.",
    milkHeader: "Milk(MK): ",
    milkDef:
      "The MK EPD is measured in pounds of calf weaning weight due to his mother’s milking ability.",
    totalMaternalHeader: "Total Maternal(TM): ",
    totalMaternalDef:
      "TM measures impact on calf weaning weight due to both milk production and the cow’s genetics for growth.",
    calvingEaseDirectHeader: "Calving Ease Direct(CED): ",
    calvingEaseDirectDef:
      "The CED EPD is listed as a percentage of unassisted calvings.",
    calvingEaseMaternalHeader: "Calving Ease Maternal(CEM): ",
    calvingEaseMaternalDef:
      "Measures the ability of a bull’s daughters to calves unassisted as two year olds.",
    stayabilityHeader: "Stayability(STAY): ",
    stayabilityDef:
      "The ST EPD predicts the ability of a bull to sire cows that “stay around”. The ST EPD is shown as a percentage of how much more likely a bull’s daughters will stay in your herd to the age of 6.",
    docilityHeader: "Docility(DOC): ",
    docilityDef: "DOC measures the temperament of the cattle.",
    max: "MAX",
    min: "MIN",
    accuracy: "ACCURACY",
    sortBy: "Sort By",
    traits:
      "Traits displayed in grey are under development, coming in Q2, 2023.",
    searchResults: "Search Results",
    recordsFound: "records found",
    compareSelected: "COMPARE SELECTED",
    animalIdentification: "Animal Identification",
    errorMessage: {
      birthWeight:
        "Birth weight maximum value cannot be less than Birth weight minimum",
      weaningWeight:
        "Weaning weight maximum value cannot be less than Weaning weight minimum",
      yearlingWeight:
        "Yearling weight maximum value cannot be less than Yearling weight minimum",
      carcassWeight:
        "Carcass weight maximum value cannot be less than Birth weight minimum",
      fatThickness:
        "Fat Thickness maximum value cannot be less than Weaning weight minimum",
      marbling:
        "Marbling maximum value cannot be less than Yearling weight minimum",
      ribeyeArea:
        "Ribeye Area maximum value cannot be less than Birth weight minimum",
      yieldGrade:
        "Yield Grade maximum value cannot be less than Weaning weight minimum",
      milk:
        "Milk maximum value cannot be less than Weaning weight minimum",
    },
    reg: "Reg#",
    name: "Name",
    sex: "Sex",
    tattoo: "Tattoo",
    dob: "DOB",
    EPD: "EPD",
    rank: "Rank",
    searchValue: "Search Value",
    typeHere: "Type here",
    searching: "Searching...",
    fetchingResult: "Fetching results...Please wait",
    animalsMatchedYourCriteria: "Animals Matched Your Criteria",
    manageAnimalsGrouping: "Manage Animals Grouping",
    manageAnimalGroupings: "Manage Animal Groupings",
    assignAnimalToContemporaryGroups: "Assign Animal To Contemporary Groups",
    resetMode: "Reset Mode",
    enterResetMode: "Enter Reset Mode",
    maintainanceMode: "Maintainance Mode",
    assigningAnimals: "Assigning Animals",
    excludedAnimals: "Excluded Animals",
    ungroupedAnimals: "Ungrouped Animals",
    assignAnimalsToCGS: "Assign Animals To CGS",
    reset: "Reinitiate Reset Flow",
    excludeAnimals: "Exclude Animals",
    resetToMaintainanceMode: "Reset Finalized - Change to Maintenance Mode",
    contemporaryGroupsSettings: "Contemporary Groups(CG) Settings",
    selectTrait: "Select Trait",
    selectTraitDescription:"Select Trait refers to the process of choosing  a specific trait",
    traitsType: {
      birthWeight: "Birth Weight",
      weaningWeight: "Weaning Weight",
      yearlingWeight: "Yearling Weight",
      carcassWeight: "Carcass Weight",
    },
    addNewGroup: "ADD NEW GROUP",
    contemporaryGroup: "Contemporary Group",
    contemporaryGroups: "Contemporary Groups",
    editGroup: "Edit Group",
    birthCGCode: "Birth(CG) Code",
    groupName: "Group Name",
    birthSex: "Birth Sex",
    conceptionMethod: "Conception Method",
    weaningCGCode: "Weaning(CG) Code",
    yearlingCGCode: "Yearling(CG) Code",
    dateWeight: "Date Weight",
    weaningyearlingCGcode: "Weaning/Yearling(CG) Code",
    carcassCGCode: "Carcass(CG) Code",
    breedOfDom: "Breed of Dam",
    addNewContemporaryGroup: "Add New Contemporary Group",
    createNewGroup: "Create New Group",
    selectFromDifferentTraits: "Select from different traits",
    contemporaryGroupName: "Contemporary Group Name",
    enterNameHere: "Enter name here",
    groupNameIsRequired: "Group Name is required",
    birthYearRange: "Birth Year Range",
    theYearAnimalWasBorn: "The year animal was born",
    birthYearIsRequired: "Birth Year is required",
    genderOfNewBornAnimal: "Gender of new born animal",
    selectSex: "Select Sex",
    theweightOfAnimalAtBirth: "The weight of animal at birth",
    maximumKg: "Maximum",
    minimumKg: "Minimum",
    aSeasonisAPeriodOfYear:
      "A season is a period of year that is distinguished by special climate conditions.",
    seasonofBirthIsRequired: "Season of Birth is required",
    majorGenericContributionOfAnimal: "Major % Generic Contribution of Animal",
    primaryBreedCompostionIsRequired: "Primary Breed Compostion is required",
    secondaryBreedCompostionIsRequired:
      "Secondary Breed Compostion is required",
    howTheAnimalWasConceived:
      "How the animal was conceived (natural mating/insemination/embryo transfer)",
    conceptionMethodIsRequired: "Conception Method is required",
    epdModelSettings: "EPD Model Settings",
    forResetMode: "For Reset Mode",
    progenyWeightingFactor: "Progeny Weighting Factor",
    weightGivenToTheProgenyFactor:
      "Weight given to the progeny factor relative to CG factor for EPD calculation in Reset mode. If only CG factor needs to be taken into account, the value of this parameter is 0.",
    enterNumber: "Enter Number",
    enterBreed: "Enter Breed",
    valueShouldBeBetween0and1: "Value should be between 0 and 1",
    resetDuration: "Reset Duration",
    timeIntervalBetweenLastAndFirstResetMode:
      "Time interval between the last and the new reset mode, at the end of which the new reset mode is enabled and new CGs and EPDs are calculated.",
    enterNumberOfDays: "Enter Number of Days",
    valueCannotBeNegative: "Value cannot be negative!",
    criticalProgenyPopulation: "Critical Progeny Population",
    minimumNumberOfProgenyRecords:
      "Minimum number of progeny records of the individual animal in the system necessary to achieve Progeny Accuracy (APD1) above 50%  (for Pedigree Accuracy)",
    criticalAncestorPopulation: "Critical Ancestor Population",
    minimumNumberOfAncestorsRecords:
      "Minimum number of ancestors records of the individual animal in the system necessary to achieve Ancestor Accuracy (APD4) above 50% (for Pedigree Accuracy)",
    forBirthWeightCG: "For Birth Weight CG",
    criticalPopulationInAnimalsContemporaryGroup:
      "Critical Population In Animal's Contemporary Group",
    minimumAverageNumberOfAnimalsPerBirthWeight:
      "Minimum average number of animals per Birth weight CG necessary to achieve Average CG Accuracy (ACG3) above 50%",
    criticalAveragePopulationPerContemporaryGroup:
      "Critical Average Population Per Contemporary Group",
    minimumNumberOfAnimalsInBirthWeight:
      "Minimum number of animals in the animal's Birth weight CG necessary to achieve CG Accuracy (ACG2) above 50%",
    forWeaningWeightCG: "For Weaning Weight CG",
    minimumAverageNumberOfAnimalsPerWeaningWeight:
      "Minimum average number of animals per Weaning weight CG necessary to achieve Average CG Accuracy (ACG3) above 50%",
    minimumNumberOfAnimalsInWeaningWeight:
      "Minimum number of animals in the animal's Weaning weight CG necessary to achieve CG Accuracy (ACG2) above 50%",
    forYearlingWeightCG: "For Yearling Weight CG",
    minimumAverageNumberOfAnimalsPerYearling:
      "Minimum average number of animals per Yearling CG necessary to achieve Average CG Accuracy (ACG3) above 50%",
    minimumNumberOfAnimalsInYearlingWeight:
      "Minimum number of animals in the animal's Yearling weight CG necessary to achieve CG Accuracy (ACG2) above 50%",
    forCarcassCG: "For Carcass CG",
    minimumAverageNumberOfAnimalsPerCarcassWeight:
      "Minimum average number of animals per Carcass weight CG necessary to achieve Average CG Accuracy (ACG3) above 50%",
    minimumNumberOFAnimalInCarcassWeight:
      "Minimum number of animals in the animal's Carcass weight CG necessary to achieve CG Accuracy (ACG2) above 50%",
    epdRequiredFieldSettings: "EPD Required Field Settings",
    pleaseSelectRequiredFieldsForCompleteEPD:
      "Please select the required fields for a complete EPD calculation",
    byDefault: "By Default",
    pleaseNoteThatUsersNotAbleToObtainFullEPD:
      "Note: Please note that users will not be able to obtain full EPD calculation if they don't provide the data fields that you mark as required.",
    pleaseNoteThatRequiredFieldParametersCannotBeChanged:
      "Note: Please note that required field parameters cannot be changed since there are already contemporary groups against previous parameters.",
    noResultFound: "NO RESULT FOUND",
    next: "Next",
    cancel: "Cancel",
    selectAnimal: "Select Animal",
    searchBy: "Search By",
    breed: "Breed",
    regDate: "Reg. Date",
    status: "Status",
    animalDetails: "Animal Details",
    add: "Add",
    update: "Update",
    dataForEPDs: " Data for EPDs",
    basicInformation: "Basic Information",
    birthWeightInformation: "Birth Weight Information",
    weaningWeightInformation: "Weaning Weight Information",
    yearlingWeightInformation: "Yearling Weight Information",
    carcassWeightInformation: "Carcass Weight Information",
    delete: "Delete",
    deleteEpdData: "Delete EPD Data",
    areYouSureYouWantToDeleteEpdData:
      "Are you sure you want to delete EPD data.",

    internationalID: "International ID",
    enterID: "Enter ID",
    animalRegistration: "Animal Registration",
    location: "Location",
    additionalIDMethod: "Additional ID Method",
    damID: "Dam ID",
    sireID: "Sire ID",

    breederHerdCode: "Breeder Herd Code",
    birthYear: "Birth Year",
    primaryBreed: "Primary Breed",
    breedComposition: "Breed Composition",
    secondaryBreed: "Secondary Breed",
    seasonofBirth: "Season of Birth",
    birthManagementCode: "Birth Management Code",
    damAge: "Dam Age",
    years: "Years",
    birthContemporaryCode: "Birth Contemporary Code",
    accuracyWeight: "Accuracy Weight",
    note: "Note",
    minimumRequiredFieldForBirthWeight:
      "Minimum required field for Birth Weight EPDs",
    birthYearGenderConceptionMethodBirthWeight:
      "Birth Year , Gender , Conception Method , Birth Weight",

    weaningWeight: "Weaning Weight",
    weaningDate: "Weaning Date",
    weaningContemporaryGroupCode: "Weaning Contemporary Group Code",
    creep: "Creep",
    managementPastureCode: "Management/Pasture Code",
    weaningSex: "Weaning Sex",
    minimumRequiredFieldForWeaningWeight:
      "Minimum required field for Weaning Weight EPDs",
    weaningWeightManagementPastureCodeWeaningSexDateWeighed:
      "Weaning Weight , Management/Pasture Code , Weaning Sex , Date Weighed",

    yearlingWeight: "Yearling Weight",
    yearlingHeight: "Yearling Height",
    yearlingDate: "Yearling Date",
    yearlingContemporaryGroupCode: "Yearling Contemporary Group Code",
    managementFeedingCode: "Management/Feeding Code",
    yearlingSex: "Yearling Sex",
    youWillNeedToFillOutFor:
      "You will need to fill out all fields to retrieve EPD data for",

    pleaseSelectHavestDateFirstToEnterInfo:
      "Please select 'Harvest Date' first to enter info for Rib Eye Area,Fat Thickness and Marbling",
    harvestDate: "Harvest Date",
    dateOnFeed: "Date On Feed",
    daysOnFeed: "Days On Feed",
    gradingDate: "Grading Date",
    carcassSex: "Carcass Sex",
    carcassWeight: "Carcass Weight",
    carcassContemporary: "Carcass Contemporary",
    damBreed: "Dam Breed",
    ribEyeArea: "Rib Eye Area",
    ribEyeAreaContemporary: "Rib Eye Area Contemporary",
    fatThickness: "Fat Thickness",
    fatThicknessContemporary: "Fat Thickness Contemporary",
    marbling: "Marbling",
    marblingContemporary: "Marbling Contemporary",
    yieldGradeContemporary: "Yield Grade Contemporary",
    animalsNotListedInContemporaryGroupsMsg:
      "Animals have not been added to any contemporary groups due to missing information. Please request the missing information from the users",
    listOfUngroupedAnimals: "List of Ungrouped Animals",
    submittingData: "Submitting Data",
    resendToUser: "Resend To User",
    submittingAnimalsInGroupMsg:
      "Submitting your animals into groups. Please wait",
    pressingResetBtnMsg:
      'Pressing the "Reset" button will initiate a process to reassign animals to their contemporary groups.',
    doYouWantToProceed: "Do you want to proceed ?",
    systemMaintainanceModeMsg:
      'Pressing the "Change to Maintenance Mode" button will initiate a process and your system will enter to the “MAINTENANCE MODE” where the EDPs calculated at the RESET will be kept constant for each animal until the next RESET (which could be 1-6 months away).',
    errorFetchingContemporaryGrpMsg: "Error fetching contemporary group data",
    deleteSuccess: "Delete Success",
    deleteSuccessMsg: "Contemporary group deleted successfully.",
    deleteFailed: "Delete Failed",
    deleteFailedMsg: "Error deleting contemporary group data",
    deleteContemporaryGrpMsg:
      "Are you sure you want to delete this contemporary group?",
    addBirthWeightData: "Add Birth Weight Data",
    addWeaningWeightData: "Add Weaning Weight Data",
    birthWeightContemporaryGroupCode: "Birth Weight Contemporary Group Code",
    dateWeighted: "Date Weighted",
    addYearlingWeightData: "Add Yearling Weight Data",
    addCarcassWeightData: "Add Carcass Weight Data",
    weaningOrYearlingContemporaryGroupCode:
      "Weaning or Yearling Weight Contemporary Group Code",
    deleteContemporaryGroupMsg:
      "Are you sure you want to delete the contemporary group?",
    updateSuccessMsg: "Contemporary group updated successfully.",
    errorMsg: "Something went wrong. Please check all the values carefully.",
    fetchErrorMsg: "Error fetching required fields for selected trait.",
    forMaintainanceMode: "For Maintainance Mode",
    ancestorsWeightFactor: "Ancestors Weight Factor",
    weightGivenToTheAncestorFactor:
      "Weight given to the ancestor factor relative to CG factor for EPD calculation in Maintenance mode. If only CG factor needs to be taken into account, the value of this parameter is 0. Initially, it is recommended to use the system's defaults.",
    addEPDModelSettingsData: "Add EPD Model Settings Data",
    minimumNumberOfAnimalsInContemporaryGroups:
      "Minimum Number of Animals in Contemporary Groups",
    enterNumberOfAnimals: "Enter Number of Animals",
    areYouSureYouWantToChangeEPDCalculation:
      "Are you sure you want to change the required EPD calculations fields?",
    weightOfAnimalAtBirth: "Weight of Animal at Birth",
    seasonIsAPeriodOfYear:
      "A season is a period of the year that is distinguished by special climate conditions.",
    codeOfBirthWeightContemporaryGroup:
      "Code of the Birth Weight Contemporary Group",
    weaningWeightOfCalf: "Weaning Weight of Calf",
    dateAnimalWasWeaned: "The date the animal was weaned",
    genderOfWeaningAnimal: "Gender of Weaning Animal",
    yearlingWeightOfCalf: "Yearling Weight of Calf",
    dateAnimalWasWeighted: "The date the animal was weighted",
    yearledAnimalSex: "The sex of the animal that was yearled",
    dateOfAnimalKilledForMeat: "Date of animal killed for meat",
    addSuccessMsg: "Contemporary group added successfully",
    traitH: "The trait for EPD calculation.",
    searchByValue:"Enter Registration No/Tattoo/Name/Tag"
  },
  listView: "List View",
  Month: "Month",
  week: 'Week',
  dailyTask: 'Daily Task',
  addTask: 'Add Task',
  todayPending: "Today's Pending",
  loadingTaskMsg: "Loading daily task... Please wait",
  task: "Task",
  actions: "Actions",
  userGuide: "User Guide",
  goToabout: "Go to About",
  userGuideD: {
    head: "Genetics and Breeding User Guide",
    headDetails1: "The admin must follow the first two flows below to calculate the EPD (Expected Progeny Differences) of animals in the system. The EPDs may then be used to value the animals and improve the breed (i.e. the traits) of their future generations",
    headDetails2: "The required animal data is provided by the breeders/farmers/users as described in the last flow below.",
    head2: "Reset Mode Flow - for the Admin User",
    head3: "Maintenance Mode Flow - For Admin User",
    head4: "Required Input Data Flow - For the Breeders/Farmers/Users",
    subHead1: "Selection of Animals for the EPD Calculations",
    subHead2: "EPD Model Settings",
    subHead3: "Required EPD Fields Settings",
    subHead4: "Contemporary Groups (CGs) Settings",
    subHead5: "Assigning Animals to Contemprary Groups (CGs)",
    subHead6: "Completing Reset Mode in order to Switch to Maintenance Mode",
    subHead7: "EPD Calculations",
    subHead8: "Maintenance Mode",
    subHead9: "Switching back to Reset Mode to update the EPDs",
    subHead10: "Required Input Data",
    desc1: "The Admin should select the animals in the system to be included in EPD Calculations",
    desc2: "The Admin Should read the model's description and input the model's settings",
    desc3: "For each trait of interest (e.g. Birth Weight, Weaning Weight, etc.), The Admin should check the fields that are required to define a contemporary group (CG)",
    desc4: "In the Contemporary Groups page, the Admin should press the [ADD NEW GROUP] button to get to the Add New Contemporary Group page. Then, for each trait of interest and for each different CG, the Admin should set the ranges for the fields required to define a particular CG (checked in 3 above) in the boxes highlighted in yellow. Each CG should have a different range of those fields.",
    desc5: "While In Reset Mode, Admin should assign the animals selected in 1 above to the CGs defined in 4 above by pressing the [ASSIGN ANIMALS TO CGs] button.",
    desc6a: "If upon assigning the animals in the system to CGs (in 5 above) the admin is satisfied with how the animals were distributed among the CGs (defined by the admin in 4 above), then the admin should switch to Maintenance Mode by pressing the [RESET FINALIZED - CHANGE TO MAINTENANCE MODE] button.",
    desc6b: "If upon assigning the animals in the system to CGs (in 5 above) the admin is NOT satisfied with how the animals were distributed among the CGs (defined by the admin in 4 above), then the admin may reinitiate Reset Mode, by pressing the [REINITIATE RESET FLOW] button, and adjust the animals selection and CGs by repeating steps 1 - 6 above (various times, if necessary) until 6a above is reached, at which point Reset Mode is completed and the system is switched to Maintenance Mode.",
    desc7: "At the time Reset Mode is completed and Maintenance Mode is started, the EPDs of all the animals that ended up in CGs is calculated and those EPD values remain the same during the entire Maintenance Mode. The Admin may see the EPD values of animals by using the “Genetic /Animals Search tool” screen.",
    desc8: "The Admin may stay in maintenance mode for any amount of time (days, weeks or months). The EPDs of new animals added to the system during Maintenance Mode are calculated by another method, if the new animal added has the necessary parameters values for such calculation.",
    desc9: "After several weeks or months in Maintenance mode, the Admin should switch back to Reset Mode in order to more accurately calculate the EPDs of all animals, specially those newly added during this last Maintenance mode. Therefore, the Admin should restart the Reset Mode flow (described in 1-6 above) and subsequently the Maintenance Mode Flow (described in 7-9 above), and this cycle can be repeated consecutively for many years.",
    desc10: "An animal's EPDs are calculated only if the system has the values of the animal's parameters that are necessary to calculate the animal's EPDs (the necessary parameters are set in 3 above). Accordingly, breeders/farmers/users must plan to regularly and accurately record and provide the proper data over the lives of many generations of their animals.",
  },
  epdD: {
    eighteight: "Purebred Black Hereford 88%",
    otherResults: "Other Results",
    Horn_Poll_Scur: "Horn/Poll/Scur",
    pedigree: "Pedigree",
    progeny: "Progeny",
    performance: "Performance",
    ownerDetail: "Owner Detail",
    expectedProgeny:"Expected Progeny Differences (EPDs)",
    gen5: "5-Generation Pedigree",
  }
};
